export default __webpack_public_path__ + "static/ASCI-85517b7f5fd9da9359124dc532611e70.png";